import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
    selector: '[checkoutCsMask]',
    standalone: true,
})
export class DataCsMaskDirective implements OnInit {
    constructor(private el: ElementRef) {}

    public ngOnInit(): void {
        this.el.nativeElement.setAttribute('data-cs-mask', '');
    }
}
